// 所有路由配置
const routes = [
  {
    path: '/',
    redirect: 'login'
  },
  {
    name: 'login',
    component: () => import('@/view/login'),
    meta: {
      title: '首页',
      showSide: false,
      showLogin: true
    }
  },
  {
    name: 'reg',
    component: () => import('@/view/reg'),
    meta: {
      title: '注册',
      showSide: false,
      showLogin: true
    }
  },
  {
    name: 'chat',
    component: () => import('@/view/chat'),
    meta: {
      title: '聊天列表',
      showSide: true,
      showLogin: false
    }
  },
  {
    name: 'friend',
    component: () => import('@/view/friend'),
    meta: {
      title: '聊天列表',
      showSide: true,
      showLogin: false
    }
  },
  {
    name: 'my',
    component: () => import('@/view/my'),
    meta: {
      title: '收藏',
      showSide: true,
      showLogin: false
    }
  },
  {
    name: 'find',
    component: () => import('@/view/find'),
    meta: {
      title: '发现',
      showSide: true,
      showLogin: false
    }
  }
]

// add route path
routes.forEach(route => {
  route.path = route.path || '/' + (route.name || '')
})

export default routes
